import React, { useState, useEffect } from 'react';
import { AiOutlineClose, AiOutlineMenu, AiOutlineArrowUp, AiOutlineDown } from 'react-icons/ai';
import logo from "../assets/logo1.png";
import { useNavigate } from "react-router-dom";

function Navbar() {
  const [nav, setNav] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeMobileMenu, setActiveMobileMenu] = useState(null);

  const navigate = useNavigate();

  const handleNav = () => {
    setNav(!nav);
    if (nav) setActiveMobileMenu(null);
  };

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const menuItems = [
    {
      title: 'Nosotros',
      links: [
        { name: 'Misión / Visión / Objetivos', path: '/Mision' },
        { name: 'Javier Duque Duque', path: '/Jdd' },
        { name: 'Equipo', path: '/Equipo' },
        { name: 'Quiénes Somos', path: '/QuienesSomos' }
      ]
    },
    {
      title: 'Qué hacemos',
      links: [
        { name: 'Premio Vida y Obra', path: '/Premio' },
        { name: 'Reconocimiento a Docentes', path: '/Docentes' },
        { name: 'Donaciones y Actividades', path: '/Donaciones' },
        { name: 'Convocatoria Premio', path: '/convocatoria' },
        { name: 'Navidad', path: '/Navidad' }
      ]
    },
    {
      title: 'Colabora',
      links: [
        { name: 'Entidades Colaboradoras', path: '/Entidades' },
        { name: 'Realiza tu donación', path: '/Colabora' }
      ]
    }
  ];

  return (
    <>
      {/* NAVBAR PRINCIPAL */}
      <nav className={`sticky top-0 z-[100] w-full transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-md py-2' : 'bg-white py-4'
      }`}>
        <div className='max-w-7xl mx-auto px-6 flex justify-between items-center'>
          
          {/* LOGO SECCION */}
          <div onClick={() => navigate("/")} className='flex items-center gap-3 cursor-pointer group'>
            <img className="w-12 md:w-14 transition-transform group-hover:scale-105" src={logo} alt="Logo" />
            <h1 className='text-md md:text-lg font-bold bg-gradient-to-r from-blue-950 to-blue-700 bg-clip-text text-transparent leading-tight'>
              Fundación Javier Duque Duque
            </h1>
          </div>

          {/* DESKTOP MENU */}
          <ul className='hidden md:flex items-center gap-6'>
            <li onClick={() => navigate("/")} className='text-sm font-semibold text-blue-950 hover:text-blue-600 cursor-pointer transition-colors'>Inicio</li>
            
            {menuItems.map((item, idx) => (
              <li key={idx} className='group relative py-4'> {/* Aumentamos padding para no perder el hover */}
                <div className='flex items-center gap-1 text-sm font-semibold text-blue-950 cursor-pointer group-hover:text-blue-600 transition-colors'>
                  {item.title} <AiOutlineDown size={10} className='group-hover:rotate-180 transition-transform duration-300'/>
                </div>
                
                {/* Dropdown - Eliminamos mt-2 y usamos top-[100%] para que no haya hueco */}
                <div className='absolute top-full left-0 w-64 bg-white shadow-2xl rounded-xl border border-gray-100 opacity-0 translate-y-2 pointer-events-none group-hover:opacity-100 group-hover:translate-y-0 group-hover:pointer-events-auto transition-all duration-300'>
                  <div className='p-2'>
                    {item.links.map((link, lIdx) => (
                      <p 
                        key={lIdx} 
                        onClick={() => navigate(link.path)} 
                        className='px-4 py-3 text-sm text-gray-600 hover:bg-blue-50 hover:text-blue-800 rounded-lg cursor-pointer transition-colors border-l-4 border-transparent hover:border-blue-600'
                      >
                        {link.name}
                      </p>
                    ))}
                  </div>
                </div>
              </li>
            ))}
            
            <li onClick={() => navigate("/Contacto")} className='bg-blue-800 text-white px-6 py-2.5 rounded-full text-sm font-bold hover:bg-blue-900 transition-all cursor-pointer shadow-lg active:scale-95'>
              Contacto
            </li>
          </ul>

          {/* MOBILE TOGGLE */}
          <div onClick={handleNav} className='md:hidden text-blue-900 cursor-pointer p-2'>
            {nav ? <AiOutlineClose size={28} /> : <AiOutlineMenu size={28} />}
          </div>
        </div>
      </nav>

      {/* MOBILE MENU (FULL SCREEN) */}
      <div className={`fixed inset-0 z-[110] bg-white transition-all duration-500 md:hidden ${
        nav ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
      }`}>
        <div className='p-6 h-full flex flex-col'>
          <div className='flex justify-between items-center mb-10'>
            <div className='flex items-center gap-2'>
              <img className="w-10" src={logo} alt="Logo" />
              <h1 className='text-sm font-bold text-blue-900'>Fundación JDD</h1>
            </div>
            <AiOutlineClose size={28} onClick={handleNav} className='text-blue-900' />
          </div>

          <ul className='flex flex-col gap-2 overflow-y-auto'>
            <li onClick={() => {navigate("/"); handleNav();}} className='text-xl font-bold text-blue-950 py-3 border-b'>Inicio</li>
            
            {menuItems.map((item, idx) => (
              <li key={idx} className='flex flex-col border-b last:border-none'>
                <div 
                  className='flex justify-between items-center text-lg font-semibold text-gray-800 py-4'
                  onClick={() => setActiveMobileMenu(activeMobileMenu === idx ? null : idx)}
                >
                  {item.title}
                  <AiOutlineDown className={`transition-transform duration-300 ${activeMobileMenu === idx ? 'rotate-180' : ''}`} />
                </div>
                
                <div className={`overflow-hidden transition-all duration-300 ${activeMobileMenu === idx ? 'max-h-96 opacity-100 mb-4' : 'max-h-0 opacity-0'}`}>
                  <ul className='bg-gray-50 rounded-xl'>
                    {item.links.map((link, lIdx) => (
                      <li 
                        key={lIdx} 
                        onClick={() => {navigate(link.path); handleNav();}}
                        className='p-4 text-gray-600 text-sm active:bg-blue-100 transition-colors'
                      >
                        {link.name}
                      </li>
                    ))}
                  </ul>
                </div>
              </li>
            ))}
            
            <li onClick={() => {navigate("/Contacto"); handleNav();}} className='mt-8 bg-blue-800 text-white text-center py-4 rounded-2xl text-lg font-bold shadow-lg shadow-blue-200'>
              Contacto
            </li>
          </ul>
        </div>
      </div>

      {/* BOTÓN VOLVER ARRIBA (Color Naranja Original) */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className={`fixed bottom-8 right-8 z-[120] bg-orange-500 text-white p-4 rounded-full shadow-2xl transition-all duration-500 hover:bg-orange-600 hover:-translate-y-2 active:scale-90 ${
          scrolled ? 'scale-100 opacity-100 visible' : 'scale-0 opacity-0 invisible'
        }`}
      >
        <AiOutlineArrowUp size={24} />
      </button>
    </>
  );
}

export default Navbar;